// Maa-amet's public address search (the same gazetteer onebox uses server-side), shared by the
// ID credit application and the contact data check. Picking a suggestion gives the whole
// address at once instead of the client typing its parts.

export const MAA_AMET_GAZETTEER = 'https://inaadress.maaamet.ee/inaadress/gazetteer';
export const ADDRESS_SEARCH_DELAY = 300;

export const searchAddresses = (query) =>
    fetch(`${MAA_AMET_GAZETTEER}?address=${encodeURIComponent(query)}&results=8&appartment=1`)
        .then(response => response.json())
        .then(data => (data && data.addresses) || []);

// With apartment search on, the gazetteer returns the apartment separately in kort_nr
// and leaves it out of aadresstekst, so "Kuklase tn 6-12" comes back as "Kuklase tn 6".
// Put it back together — the contract needs the full address.
export const addressStreet = (address) =>
    (address.kort_nr ? `${address.aadresstekst}-${address.kort_nr}` : address.aadresstekst) || '';

// The gazetteer's own label starts with the same street text, so swap that first part
// for the one that includes the apartment and keep the town/county tail as it is.
export const addressLabel = (address) => {
    const tail = (address.ipikkaadress || address.pikkaadress || '')
        .split(',')
        .slice(1)
        .map(part => part.trim())
        .filter(Boolean);
    // Settlement-level matches have no street part at all, so drop it rather than
    // starting the label with a stray comma.
    return [addressStreet(address), ...tail].filter(Boolean).join(', ');
};

// In cities the settlement is the district ("Mustamäe linnaosa"), but a postal address
// wants the city itself, so fall back to the municipality in that case.
export const addressSettlement = (address) => {
    const settlement = address.asustusyksus || '';
    return /linnaosa$/i.test(settlement) ? (address.omavalitsus || settlement) : settlement;
};

// A gazetteer match in the shape fin_crm_client keeps a client's address, the same one the
// intranet's Business Register sync writes: state = maakond, county = omavalitsus,
// city = asustusüksus.
export const accountAddressFromGazetteer = (address) => ({
    street: addressStreet(address),
    city: address.asustusyksus || address.omavalitsus || '',
    county: address.omavalitsus || '',
    state: address.maakond || '',
    zip: address.sihtnumber || '',
    adrId: address.adr_id ? String(address.adr_id) : null,
});

// "Kuklase tn 6-12, Mustamäe linnaosa, Tallinn 13423" - a town that is its own municipality
// ("Tartu linn, Tartu linn") is named once.
export const formatAccountAddress = (address) => {
    if (!address) {
        return '';
    }
    const places = [address.street, address.city, address.county]
        .map(part => (part || '').trim())
        .filter((part, index, parts) => part && parts.indexOf(part) === index);
    const text = places.join(', ');
    return address.zip ? `${text} ${address.zip}`.trim() : text;
};
